import { ProfileCollectionService } from './../../profile-collection/services/profile-collection.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProfileCollectionModel } from '@app/profile/profile-api.model';
import { LEARNING_TYPES } from '@app/profile/components/profile-overview/profile-overview.service';
import { InputDetails } from '@app/inputs/inputs-api.model';

@Injectable({
  providedIn: 'root',
})
export class ProfileLearningService {
  constructor(private profileCollectionService: ProfileCollectionService) {}
  /**
   *
   * @param userKey - The key for the user
   * @param start - The start index
   * @param count - How many experiences to return
   * @param tagName (Optional) - Get learnings that have been tagged with this tag name
   * @param learningType (Optional) - Get the learnings only for this type
   * @param providers (Optional) - Get the learnings only for these providers
   */
  public getMostRecentLearningsModel(
    userKey: number,
    start: number,
    count: number,
    tagName: string = '',
    learningType: string,
    providers: string[]
  ): Observable<ProfileCollectionModel<InputDetails>> {
    const facets = [
      {
        id: 'Type',
        values: learningType ? [learningType] : LEARNING_TYPES,
      },
    ];
    if (providers.length) {
      facets.push({
        id: 'Provider',
        values: providers,
      });
    }
    return this.profileCollectionService.getCollectionModel(
      userKey,
      facets,
      start,
      count,
      tagName,
      ''
    );
  }
}
